var pym = require("./lib/pym");
var pymChild = null; 
var $ = require("./lib/qsa")
require("./lib/webfonts");
var { isMobile } = require("./lib/breakpoints");

var waterfallContainer = $.one(".waterfall-wrapper");
var waterfallItems = $(".waterfall-wrapper .waterfall-item");
var reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

var refreshButton = $.one(".refresh-btn");

var onWindowLoaded = function() {

  pym.then(child => {
    pymChild = child;
    setItemMargins();

    // show items when visible on screen 
    if (!reducedMotion.matches) {
      var observer = new IntersectionObserver(itemVisible, { threshold: 0.5 }); 

      waterfallItems.forEach((item, i) => {
        item.classList.add("pubbed"); 
        observer.observe(item); 
      }); 
    } else {
      item.classList.add("pubbed"); 
    }

    refreshButton.addEventListener('click', animate);

    child.sendHeight();
    window.addEventListener("resize", () => child.sendHeight());
  });
}

var animate = function() {
  var observer = new IntersectionObserver(itemVisible, { threshold: 0.5 }); 
  console.log("yeet");

  // get rid of pubbed
  waterfallItems.forEach(function(item) {
    if (item.classList.contains("pubbed")) {
      item.classList.remove("pubbed");
      setTimeout(()=>{
        item.classList.add("pubbed")
      },1000)
    }
  })

  // add back pubbed

}


var setItemMargins = function() {
  waterfallItems.forEach((item, i) => {
    if (isMobile.matches) {
      item.style.marginLeft = 0; 
      item.style.marginTop = item.dataset.marginTop; 
      item.style.zIndex = i * 10; 
    } else {
      item.style.marginLeft = item.dataset.marginLeft; 
      item.style.marginTop = item.dataset.marginTop; 
      item.style.zIndex = i * 10; 
    }
  })
}

var itemVisible = function(e) {
  e.forEach((item, i) => {
    if (item.isIntersecting) {
      // console.log("visible", item);
      item.target.classList.add("pubbed");
      // item.target.classList.remove("inactive");
    } else {
      // console.log("not visible", item);
      // item.target.classList.remove("active");
      // item.target.classList.add("inactive");
    }
  });
  pymChild.sendHeight();
}

// Initially load the graphic
// wait for images to load. see: https://developer.mozilla.org/en-US/docs/Web/API/Window/load_event
window.addEventListener("load", onWindowLoaded);